export const types = {
  centroscostosLoaded: "[centrocosto] centros de costos Loaded",
  centrocostoSetActive: "[centrocosto] centro de costo Set Active",
  centrocostoClearActive: "[centrocosto] centro de costo Clear Active",
  centrocostoAdded: "[centrocosto] centro de costo added",
  centrocostoUpdated: "[centrocosto] centro de costo updated",
  centrocostoDeleted: "[centrocosto] centro de costo deleted",
  centrocostoLoading: "[centrocosto] centro de costo Loading Data",
};
